export default "__VITE_ASSET__BZE6HT10__"